<template>
  <ArendenPreview />
  <div class="flex flex-col items-center gap-xs py-sm" v-if="arende.isLoading">
    <SmallSpinner />
    <span>Laddar ärendet...</span>
  </div>
  <template v-else>
    <h2 class="type-heading-md my-sm">{{ arende.data?.rubrik }}</h2>
    <ArendeIdDate
      class="mb-sm"
      :id="arende.data?.id"
      :date="formatDateToYYYYMMDD(arende.data?.createdAt)"
    />
    <ArendeForm :arende="arende.data!" />
  </template>
</template>
<script setup lang="ts">
import { computed } from "vue";

import ArendeIdDate from "@/components/arende-components/ArendeIdDate.vue";
import SmallSpinner from "@/components/ui/SmallSpinner.vue";
import { formatDateToYYYYMMDD } from "@/common/formatters";

import { useAnstalldarendeStore } from "../../store";
import ArendeForm from "../ArendeForm.vue";
import ArendenPreview from "./ArendenPreview.vue";

const arendeStore = useAnstalldarendeStore();
const arende = computed(() => arendeStore.arende);
</script>
